import gql from 'graphql-tag';
import FRAGMENTS from '_Resources/Cards/Services/GraphQl/FRAGMENTS';

const query = gql`
  query getThematicsOverviewData(
    $projectId: Int!
    $range: DateRangeInput!
    $criteriaKeys: [CriteriaKey!]
    $thematics: [ThematicInput!]
    $keywords: [String!]
    $dataCollectorId: Int
    $thematicSelectionId: Int
  ) {
    getThematicsOverviewData(
      projectId: $projectId
      range: $range
      criteriaKeys: $criteriaKeys
      thematics: $thematics
      keywords: $keywords
      dataCollectorId: $dataCollectorId
      thematicSelectionId: $thematicSelectionId
    ) {
      settings
      verbatimsWithoutThematicCount
      thematics {
        thematicsOverviewDetails {
          name
          mentionCount
        }
        subThematics {
          subSubThematics {
            thematicsOverviewDetails {
              ...ThematicsOverviewFragment
            }
          }
          thematicsOverviewDetails {
            ...ThematicsOverviewFragment
          }
        }
        thematicsOverviewDetails {
          ...ThematicsOverviewFragment
        }
      }
    }
  }
  ${FRAGMENTS.thematicsOverview}
`;

export default query;
